module.exports = __webpack_public_path__ + "media/images/icons/heart-1f69c5c5eaef7fbda7f301d41aa42458.svg";